import { createSelector } from '@reduxjs/toolkit';
import { AppRootState } from '@reduxStore';

export const selectAppFeatures = createSelector(
	(appState: AppRootState | null | undefined) => appState,
	(appState) => appState?.appSettings?.features ?? undefined
);

export const selectTerminal = createSelector(
	(appState: AppRootState | null | undefined) => appState,
	(appState) => appState?.applicationState.selectedTerminal ?? undefined
);
